module.exports = __webpack_public_path__ + "img/BZ1.91837a20.svg";